import React from "react";
import SlaSummary, { SLA_RULE } from "../../../../components/slaSummary/SlaSummary";
import { fmtPercent, slaTone, TONE_TEXT } from "../../../../components/slaSummary/slaFormat";
import { TicketSlaCompliance } from "../../../../interfaces/Ticket";

interface Props {
  data: TicketSlaCompliance;
  /** Colaborador do filtro da tela; a linha dele aparece marcada. */
  selectedAssigneeId: number | null;
  selectedUnassigned: boolean;
  /** Clique numa linha aplica o filtro de colaborador DA TELA (lista e indicador juntos). */
  onSelectAssignee: (employeeId: number | null) => void;
}

/**
 * Detalhe do indicador de SLA: contagens, tendência e quebra por colaborador. Sem filtros próprios:
 * responde à barra de filtros do cabeçalho, como a lista.
 */
const SlaDetails: React.FC<Props> = ({ data, selectedAssigneeId, selectedUnassigned, onSelectAssignee }) => (
  <div className="flex flex-col gap-4 lg:flex-row">
    <div className="min-w-0 flex-1">
      <SlaSummary data={data} />
      <p className="mt-2 text-xs text-gray-700 dark:text-gray-300">{SLA_RULE}</p>
    </div>

    {data.byAssignee.length > 0 && (
      <div className="min-w-0 overflow-x-auto lg:w-[420px]">
        <table className="w-full min-w-[360px] text-left text-sm">
          <caption className="mb-2 text-left text-xs font-medium text-gray-700 dark:text-gray-300">
            Por colaborador (clique para filtrar a tela)
          </caption>
          <thead>
            <tr className="text-xs text-gray-700 dark:text-gray-300">
              <th scope="col" className="py-1.5 pr-3 font-semibold">Colaborador</th>
              <th scope="col" className="px-3 py-1.5 text-right font-semibold">Chamados</th>
              <th scope="col" className="px-3 py-1.5 text-right font-semibold">% resolução</th>
              <th scope="col" className="py-1.5 pl-3 text-right font-semibold">% resposta</th>
            </tr>
          </thead>
          <tbody>
            {data.byAssignee.map((a) => {
              const ativo = a.employeeId == null ? selectedUnassigned : a.employeeId === selectedAssigneeId;
              return (
                <tr
                  key={a.employeeId ?? "sem-responsavel"}
                  className={`border-t border-gray-100 dark:border-white/10 ${ativo ? "bg-dv-blue-500/10" : ""}`}
                >
                  <td className="py-2 pr-3 font-medium text-navy-700 dark:text-white">
                    <button
                      type="button"
                      onClick={() => onSelectAssignee(a.employeeId)}
                      aria-pressed={ativo}
                      className="text-left underline-offset-2 hover:underline focus-visible:underline"
                    >
                      {a.name}
                    </button>
                  </td>
                  <td className="px-3 py-2 text-right tabular-nums text-gray-700 dark:text-gray-300">{a.total}</td>
                  <td className={`px-3 py-2 text-right font-semibold tabular-nums ${TONE_TEXT[slaTone(a.resolution.percent)]}`}>
                    {fmtPercent(a.resolution.percent)}
                  </td>
                  <td className={`py-2 pl-3 text-right font-semibold tabular-nums ${TONE_TEXT[slaTone(a.response.percent)]}`}>
                    {fmtPercent(a.response.percent)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    )}
  </div>
);

export default SlaDetails;
